import { Code, ConnectError } from '@connectrpc/connect';

/**
 * Стоит ли после отказа gRPC делать ЗАПАСНОЙ заход в REST.
 *
 * ⚠️ Раньше запасной заход делался всегда — и это был SNMP после SNMP. Обе ручки
 * (`getDeviceFDB` по Connect и `GET /devices/:id/fdb`) ходят в ОДИН use case Direct SNMP,
 * так что если сервер уже ответил отказом, он к устройству сходил, и второй заход туда же
 * стоит оператору лишнего ожидания. Замер на стенде (устройство не отвечает):
 * `/devices/:id/fdb` — 500 через **60.0 с** поверх ~25 с первой попытки. До 85 секунд,
 * из которых 60 бессмысленны.
 *
 * Запасной путь осмыслен только при локальном сбое fetch. `Code.Unavailable` нельзя
 * считать его признаком: сервер также возвращает этот код при недоступном admission
 * бюджете (HTTP 503). Серверный отказ не должен превращаться во второй опрос REST.
 */
export function shouldRetryViaRest(error: unknown, signal?: AbortSignal): boolean {
  if (signal?.aborted) return false;
  if (error instanceof ConnectError) {
    return error.code === Code.Unknown && error.cause instanceof TypeError;
  }
  return error instanceof TypeError;
}
